import auditTrailFiltersSignal, {
	setAuditTrailFilters,
} from '@UI/Pages/Administration/AuditTrail/Filters/Signals/auditTrailFiltersSignal';
import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { MultiSelect } from '@verclam/ui-kit';

type Props = {
	readonly options: readonly { readonly value: string; readonly label: string }[] | null;
	readonly withLabel?: boolean;
};

const ActionFilter: React.FC<Props> = ({ options, withLabel = false }) => {
	const currentFilters = useSignalValue(auditTrailFiltersSignal);

	const handleChange = React.useCallback((selection: readonly string[]) => {
		setAuditTrailFilters(auditTrailFiltersSignal.peek().setAction(selection));
	}, []);

	return (
		<MultiSelect<string>
			name="auditTrailAction"
			label="Action"
			isLabelHidden={!withLabel}
			placeholder="Toutes les actions"
			options={options ?? []}
			optionLabel="label"
			optionValue="value"
			loading={options === null}
			value={currentFilters.action}
			onChange={handleChange}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default ActionFilter;
